import React , {useState} from "react";
import { useNavigate, Link } from "react-router-dom";
import PdLogo from "../../../assets/media/logo/pd_logo_(orange).png";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../store/slices/basicInfo";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuBar from '../../../components/Header/MenuBar';
import Button from '@mui/material/Button';
import avatar from "../../../assets/media/avatar.png";



const Header = () => {
  const [profile_menu, setProfile_menu] = useState('close')
  const userDetail = useSelector((state) => state.basicInfo?.userDetails);

  const isAuthenticated = useSelector(
    (state) => state.basicInfo.isAuthenticated
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    dispatch(logout());
    window.location.href = `/`;
  };

  
  const open_profile_menu = () => {
    profile_menu === 'close' ? setProfile_menu('open') : setProfile_menu('close');
  };

  
  document.addEventListener('click', function(e){
    const user_header_usefull_link = document.getElementById('user-header-nav');
    const user_header_profile_img = document.getElementById('user-header-img');

    if(profile_menu === 'open'){
        if(!user_header_usefull_link.contains(e.target) && 
          !user_header_profile_img.contains(e.target)){
            setProfile_menu('close');
        }
      }
  });



  return (
    <header className="home-header-logged" profile-menu={profile_menu}>
      <div className="container-fluid">
        <div className="header-navigations">
          <a href="/">
            <div id="logo">
              <img src={PdLogo} alt="" />
            </div>
          </a>

          <div className="nav-bar">
            {
              isAuthenticated &&
              <div className="user-userfull-link-and-info" id="user-header-nav">
                <div>
                  <span className="total-balance">
                    Total Balance : {userDetail?.balance} $
                  </span>

                  <Link to={"/profile-information/"}>
                    <i className="fa-solid fa-user"></i> Profile
                  </Link>
                  <Link to="/update-profile/profile-information">
                    <i className="fa-solid fa-gear"></i> Settings
                  </Link>
                  <button onClick={handleLogout}>
                    <i className="fa-solid fa-arrow-right-from-bracket"></i> Log
                    Out
                  </button>
                </div>
              </div>
            }

            {/* <a href="/">Home</a>
            <a href="#">Load Feed</a>
            <a href="#">Order</a> */}

            <a className="rspv-nav-bar" href="#/" onClick={handleLogout}>
              Log Out
            </a>

            <div className="right-side-btn">
              {!isAuthenticated && (
                <>
                  <Button component="a" className="sign-in-up" href="/auth/sign-in">
                    Sign In
                  </Button>

                  <Button component="a" className="sign-in-up" href="/auth/sign-up">
                    Sign Up
                  </Button>
                </>
              )}
              {isAuthenticated && (
                <div
                  className="user-img"
                  id="user-header-img"
                  onClick={open_profile_menu}
                >
                  {
                    userDetail ?
                    <img src={userDetail?.profile_picture || avatar} alt="Image" /> :
                    <AccountCircleIcon/>
                  }
                </div>
              )}
            </div>
          </div>

          <MenuBar/>
        </div>
      </div>
    </header>
  );
};

export default Header;
